import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useSnackbar } from "notistack";
import { onRateLimited } from "network/rate-limit";

const SNACKBAR_KEY = "rate-limited";

// Shows one warning when requests keep hitting HTTP 429 after the automatic retries.
const RateLimitNotifier = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(
    () =>
      onRateLimited(() => {
        enqueueSnackbar(intl.formatMessage({ id: "common.error.rateLimited" }), {
          key: SNACKBAR_KEY,
          preventDuplicate: true,
          variant: "warning",
        });
      }),
    [enqueueSnackbar, intl],
  );

  return null;
};

export default RateLimitNotifier;
